import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'
Validator.addLocale(zh)
const config = {
  locale: 'zh_CN'
}
Vue.use(VeeValidate, config)
const dictionary = {
  zh_CN: {
    messages: {
      required: (field) => '请输入' + field
    },
    attributes: {
      email: '邮箱',
      password: '密码',
      name: '账号',
      phone: '手机号',
      code: '验证码',
      userName: '用户名',
      account: '支付宝账号',
      zfbName: '支付宝姓名',
      money: '提取现金',
      newpasswordAgain: '确认密码',
    }
  }
}

Validator.updateDictionary(dictionary)

Validator.extend('phone', {
  messages: {
    zh_CN: field => '手机号格式错误'
  },
  validate: value => {
    return value.length === 11 && /^1[0-9]{10}$/i.test(value)
  }
})
Validator.extend('password', {
  messages: {
    zh_CN: field => '密码格式错误'
  },
  validate: value => {
    return /^[a-zA-Z0-9]{6,16}$/i.test(value)
  }
})

Validator.extend('newpasswordAgain', {
  messages: {
    zh_CN: field => '两次密码不一致'
  },
  validate: value => {
    return value === password
  }
})
Validator.extend('account', {
  messages: {
    zh_CN: field => '请输入有效的支付宝账号'
  },
  validate: value => {
    return (value.length === 11 && /^((13[0-9])|(14[0-9])|(15[^4,\D])|(18[0,0-9])|(17[0-9])|(19[0-9]))\d{8}$/i.test(value)) || (/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value))
  }
})



// WEBPACK FOOTER //
// ./src/validate/validate.js